import { css } from "styled-components";
import {
  mediumParagraph,
  largeHeading,
  mediumHeading,
  ResponsiveImage,
  media,
} from "@nested/brand";
import { ButtonLink } from "@nested/component-library";

const container = css`
  box-sizing: border-box;
  padding: 30px 10px;
  width: 100%;
  text-align: center;

  ${media.tablet`
    text-align: left;
    padding: 0;
    max-width: 550px;
    padding: 0 30px;
    margin: 50px auto;
  `}
  p:last-of-type {
    margin: 15px 0 0;
  }
`;

const headingStyle = css`
  margin: 15px 0 0;
  ${mediumHeading}
  ${media.tablet`
  ${largeHeading}
    margin: 30px 0 0;
  `}
`;

const paragraphStyles = css`
  margin: 15px 0 0;

  ${mediumParagraph}
  ${media.tablet`
    margin: 30px 0 0;
  `}
    strong {
    font-weight: 500;
  }
`;

const buttonStyle = css`
  margin-top: 30px;
`;

const imageStyle = css`
  width: 100%;
`;

export const ManualOnboardingThankYou = () => (
  <div css={container} data-test="thank-you-component">
    <ResponsiveImage
      src="https://nested.imgix.net/illustrations/couple_with_dog.png"
      alt="couple with dog"
      css={imageStyle}
    />
    <h1 css={headingStyle}>
      We're excited to show you all that Nested has to offer
    </h1>
    <p css={paragraphStyles}>
      Thanks for your details, that is all we need to know. Your local agent
      will be in touch with you shortly.
    </p>
    <ButtonLink to="/" type="primary" css={buttonStyle}>
      Go to Homepage
    </ButtonLink>
  </div>
);
